import { Controllers } from 'lib/enums/routes/_controllers';
import { AccountsRoutes } from 'lib/enums/routes/accounts';
import { AccountDoc, AccountWhole } from 'lib/interfaces/database/account';
import { BaseService } from 'services/_base';

export class AccountsService extends BaseService {
  private static instance: AccountsService;

  static getInstance(): AccountsService {
    if (!AccountsService.instance) {
      AccountsService.instance = new AccountsService();
    }

    return AccountsService.instance;
  }

  private constructor() {
    super({
      controller: Controllers.accounts,
    });
  }

  search(payload: Partial<AccountDoc>) {
    return this.POST(
      {
        uri: AccountsRoutes.Search,
      },
      payload
    )
      .then((result: AccountWhole[]) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  create(payload: Partial<AccountDoc>) {
    return this.POST(
      {
        uri: AccountsRoutes.CreateOne,
      },
      payload
    )
      .then((result: AccountWhole) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  update(id: string, payload: Partial<AccountDoc>) {
    return this.PUT(
      {
        uri: `${AccountsRoutes.UpdateOne}/${id}`,
      },
      payload
    )
      .then((result: AccountWhole) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }
}
